<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    :fill="fill || 'black'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_52_17944)">
      <path
        d="M4.0163 0.0739403C3.31903 0.258511 2.72021 0.873745 2.56435 1.57511C2.50692 1.83351 2.50282 2.63742 2.51103 9.10558C2.52333 15.6927 2.52743 16.3571 2.58896 16.4884C2.68329 16.6935 6.87919 20.8607 7.06786 20.9386C7.29345 21.0329 16.5425 21.0288 16.9362 20.9386C17.6622 20.7663 18.2446 20.1921 18.4374 19.462C18.4907 19.2487 18.4989 18.1987 18.4989 10.5001C18.4989 0.89015 18.5153 1.56691 18.2446 1.05832C17.978 0.557924 17.412 0.143667 16.8624 0.0411282C16.7229 0.0165195 14.4138 0.000112534 10.464 0.00421333C4.76278 0.00421333 4.26649 0.00831604 4.0163 0.0739403ZM16.7763 1.43566C16.8624 1.48078 16.9772 1.57511 17.0306 1.64894L17.1249 1.78429V10.5001V19.2159L17.0265 19.3554C16.9731 19.4292 16.8542 19.5277 16.7599 19.5687C16.5999 19.6425 16.3948 19.6466 12.2974 19.6466H7.99892V17.805V15.9675L7.90458 15.828C7.85536 15.7542 7.74872 15.6476 7.67489 15.5984L7.53544 15.504H5.69794H3.85634V8.70363V1.89914L3.95067 1.71867C4.0163 1.59152 4.09833 1.50949 4.22548 1.44386L4.40595 1.35363H10.5132C16.5097 1.35363 16.6163 1.35363 16.7763 1.43566ZM6.6454 17.7599C6.6454 18.2562 6.6413 18.6622 6.6331 18.6622C6.62899 18.6622 6.21884 18.2562 5.72255 17.7599L4.82021 16.8575H5.73485H6.6454V17.7599Z"
        fill-opacity="0.8"
      />
      <path
        d="M12.8971 2.85396C12.8315 2.88677 12.1219 3.56353 11.3303 4.35923L9.88247 5.79888L9.39849 5.319C8.77915 4.70787 8.59048 4.62584 8.21724 4.794C8.00806 4.88834 7.8686 5.08111 7.84399 5.3108C7.80708 5.63072 7.8645 5.71685 8.72583 6.56998C9.40669 7.25084 9.56255 7.38209 9.7102 7.419C10.0916 7.52154 10.0547 7.55435 11.9866 5.62662C12.9545 4.66275 13.7708 3.82193 13.8077 3.7563C13.8938 3.58814 13.8651 3.2108 13.7461 3.04673C13.5739 2.80474 13.1678 2.71451 12.8971 2.85396Z"
        fill-opacity="0.8"
      />
      <path
        d="M6.38184 9.29512C6.10703 9.43867 5.99219 9.61914 5.99219 9.91855C5.99219 10.14 6.09473 10.3287 6.2916 10.4764C6.40645 10.5625 6.41465 10.5625 10.4834 10.5625C14.5357 10.5625 14.5604 10.5625 14.6711 10.4764C15.0895 10.1646 15.0895 9.64785 14.6711 9.33613C14.5604 9.25 14.5275 9.25 10.5326 9.2377C6.93965 9.22949 6.49258 9.2377 6.38184 9.29512Z"
        fill-opacity="0.8"
      />
      <path
        d="M6.31214 12.8105C5.88558 13.0976 5.87327 13.6678 6.28753 13.9385L6.45569 14.0492L10.385 14.0615C12.9731 14.0656 14.3717 14.0574 14.4743 14.0287C14.9295 13.9057 15.1305 13.393 14.8762 13.0074C14.6711 12.6957 14.9623 12.7162 10.467 12.7162H6.45159L6.31214 12.8105Z"
        fill-opacity="0.8"
      />
      <path
        d="M9.72699 16.2153C9.52601 16.2768 9.32094 16.5311 9.28812 16.7485C9.25121 16.9864 9.36605 17.2571 9.55883 17.3965L9.69828 17.495L12.0895 17.5073C14.7719 17.5196 14.6735 17.5278 14.8745 17.2242C15.0467 16.9617 15.0016 16.5639 14.776 16.3588C14.5627 16.1619 14.5422 16.1619 12.1305 16.166C10.6745 16.1701 9.81312 16.1866 9.72699 16.2153Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_52_17944">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'SummarizerIcon',
  props: {
    fill: String
  }
};
</script>
